import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import Layout from '@/layout'
import { DEFAULT_REDIRECT, buildLoginLocation } from '@/utils/redirect'
import { canAccessRoute } from './access'

Vue.use(Router)

export const asyncRouteRegistry = {
  '/dashboard': {
    path: 'dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/index.vue'),
    meta: { title: '工作台', icon: 'el-icon-data-board' }
  },
  '/project/list': {
    path: 'project/list',
    name: 'ProjectList',
    component: () => import('@/views/project/list.vue'),
    meta: { title: '项目列表', icon: 'el-icon-folder-opened' }
  },
  '/project/members': {
    path: 'project/members',
    name: 'ProjectMembers',
    component: () => import('@/views/project/members.vue'),
    meta: { title: '项目成员列表', icon: 'el-icon-user' }
  },
  '/project/interview-config': {
    path: 'project/interview-config',
    name: 'ProjectInterviewConfig',
    component: () => import('@/views/interview/index.vue'),
    meta: { title: '访谈配置', icon: 'el-icon-setting' }
  },
  '/service-items': {
    path: 'service-items',
    name: 'ServiceItemList',
    component: () => import('@/views/service-item/index.vue'),
    meta: { title: '服务事项', icon: 'el-icon-document-checked' }
  },
  '/persons': {
    path: 'persons',
    name: 'PersonList',
    component: () => import('@/views/person/index.vue'),
    meta: { title: '服务对象', icon: 'el-icon-user' }
  },
  '/process-items': {
    path: 'process-items',
    name: 'ProcessItemList',
    redirect: to => ({
      path: '/report-workbench',
      query: to.query
    }),
    meta: { title: '过程文件', hidden: true, internal: true }
  },
  '/report-workbench': {
    path: 'report-workbench',
    name: 'ReportWorkbench',
    component: () => import('@/views/report-workbench/index.vue'),
    meta: { title: '报告撰写工作台', icon: 'el-icon-edit-outline' }
  },
  '/templates': {
    path: 'templates',
    name: 'TemplateList',
    component: () => import('@/views/template/index.vue'),
    meta: { title: '模板管理', icon: 'el-icon-tickets' }
  },
  '/users': {
    path: 'users',
    name: 'UserList',
    component: () => import('@/views/user/index.vue'),
    meta: { title: '用户管理', icon: 'el-icon-user-solid' }
  },
  '/departments': {
    path: 'departments',
    name: 'DepartmentList',
    component: () => import('@/views/department/index.vue'),
    meta: { title: '部门管理', icon: 'el-icon-office-building' }
  },
  '/companies': {
    path: 'companies',
    name: 'CompanyList',
    component: () => import('@/views/company/index.vue'),
    meta: { title: '公司管理', icon: 'el-icon-house' }
  },
  '/documents': {
    path: 'documents',
    name: 'DocumentList',
    component: () => import('@/views/document/index.vue'),
    meta: { title: '文档资料', icon: 'el-icon-folder' }
  },
  '/media': {
    path: 'media',
    name: 'MediaList',
    component: () => import('@/views/media/index.vue'),
    meta: { title: '媒体上传', icon: 'el-icon-upload' }
  },
  '/statistics': {
    path: 'statistics',
    name: 'Statistics',
    component: () => import('@/views/statistics/index.vue'),
    meta: {
      title: '统计监测',
      icon: 'el-icon-pie-chart',
      legacyPath: '/view/statistics/statisticsList.action'
    }
  },
  '/cameras': {
    path: 'cameras',
    name: 'CameraList',
    component: () => import('@/views/camera/index.vue'),
    meta: { title: '摄像头管理', icon: 'el-icon-camera' }
  },
  '/rooms': {
    path: 'rooms',
    name: 'RoomList',
    component: () => import('@/views/room/index.vue'),
    meta: { title: '录像室管理', icon: 'el-icon-house' }
  },
  '/videos': {
    path: 'videos',
    name: 'VideoList',
    component: () => import('@/views/video/index.vue'),
    meta: { title: '视频', icon: 'el-icon-video-camera' }
  },
  '/interviews': {
    path: 'interviews',
    name: 'InterviewList',
    component: () => import('@/views/interview/index.vue'),
    meta: { title: '现场走访', icon: 'el-icon-microphone' }
  },
  '/approval': {
    path: 'approval',
    name: 'Approval',
    component: () => import('@/views/approval/index.vue'),
    meta: { title: '审批管理', icon: 'el-icon-s-check' }
  },
  '/deliverables': {
    path: 'deliverables',
    name: 'DeliverableList',
    component: () => import('@/views/deliverable/tree-index.vue'),
    meta: {
      title: '成果管理',
      icon: 'el-icon-medal',
      legacyPath: '/view/deliverable/deliverableList.jsp'
    }
  },
  '/shares': {
    path: 'shares',
    name: 'ShareMaterialList',
    component: () => import('@/views/share/tree-index.vue'),
    meta: {
      title: '焦点关注',
      icon: 'el-icon-star-on',
      legacyPath: '/view/share/shareMaterialList.jsp'
    }
  },
  '/performance': {
    path: 'performance',
    name: 'PerformanceList',
    component: () => import('@/views/legacy-top-pages/performance-index.vue'),
    meta: {
      title: '绩效评估',
      icon: 'el-icon-data-analysis',
      legacyPath: '/view/performance/performanceList.jsp'
    }
  },
  '/project-evaluations': {
    path: 'project-evaluations',
    name: 'ProjectEvaluationList',
    component: () => import('@/views/evaluation/index.vue'),
    meta: {
      title: '项目评估',
      icon: 'el-icon-data-line',
      legacyPath: '/view/evaluation/projectEvaluationList.jsp'
    }
  },
  '/project-evaluations/material': {
    path: 'project-evaluations/material',
    name: 'ProjectEvaluationMaterial',
    component: () => import('@/views/evaluation/material.vue'),
    meta: {
      title: '评估资料',
      hidden: true,
      internal: true,
      legacyPath: '/view/evaluation/projectEvaluationMaterial.jsp'
    }
  },
  '/legacy-menu': {
    path: 'legacy-menu/:menuKey',
    name: 'LegacyMenuPlaceholder',
    component: () => import('@/views/legacy-menu-placeholder/index.vue'),
    meta: {
      title: '旧系统菜单',
      icon: 'el-icon-menu',
      migrationStatus: '该旧系统功能已识别并保留菜单入口，完整 Vue 复刻纳入 P1 / 后续迁移。'
    }
  },
  '/system/permission': {
    path: 'system/permission',
    name: 'PermissionAdmin',
    component: () => import('@/views/permission/index.vue'),
    meta: { title: '菜单权限', icon: 'el-icon-set-up' }
  },
  '/system/roles': {
    path: 'system/roles',
    name: 'RoleAdmin',
    component: () => import('@/views/permission/index.vue'),
    meta: { title: '角色管理', icon: 'el-icon-user', permissionPage: 'roles' }
  },
  '/system/modules': {
    path: 'system/modules',
    name: 'ModuleAdmin',
    component: () => import('@/views/permission/index.vue'),
    meta: { title: '模块管理', icon: 'el-icon-menu', permissionPage: 'modules' }
  },
  '/system/role-authorization': {
    path: 'system/role-authorization',
    name: 'RoleAuthorization',
    component: () => import('@/views/permission/role-authorization.vue'),
    meta: { title: '角色授权', icon: 'el-icon-key' }
  },
}

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/legacy.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/login-bak',
    component: () => import('@/views/login/legacy.vue'),
    props: { backup: true },
    meta: { title: '登录' }
  },
  {
    path: '/register',
    component: () => import('@/views/login/register.vue'),
    meta: { title: '系统注册' }
  },
  {
    path: '/media-test',
    component: () => import('@/views/media/test.vue'),
    meta: { title: 'Insert title here' }
  }
]

const internalWorkflowRoutePaths = [
  '/project/members',
  '/project/interview-config',
  '/project-evaluations/material',
  '/service-items',
  '/process-items',
  '/documents',
  '/report-workbench',
  '/cameras',
  '/system/role-authorization',
  '/legacy-menu'
]

function asInternalWorkflowRoute(route) {
  if (!route) return route
  return {
    ...route,
    meta: {
      ...(route.meta || {}),
      hidden: true,
      internal: true
    }
  }
}

export function buildLayoutRoute(children) {
  const internalWorkflowRoutes = internalWorkflowRoutePaths
    .map(path => asInternalWorkflowRoute(asyncRouteRegistry[path]))
    .filter(Boolean)
  const routeChildren = internalWorkflowRoutes.reduce((routes, extraRoute) => {
    if (!extraRoute || routes.some(route => route && route.name === extraRoute.name)) {
      return routes
    }
    return routes.concat(extraRoute)
  }, children)
  return {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: routeChildren
  }
}

function createRouter() {
  return new Router({
    mode: 'hash',
    routes: constantRoutes
  })
}

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.beforeEach(async (to, from, next) => {
  const token = store.getters.token
  if (to.path === '/media-test' || to.path === '/register') {
    next()
    return
  }
  if (to.path === '/login' || to.path === '/login-bak') {
    next()
    return
  }

  if (!token) {
    next(buildLoginLocation(to.fullPath))
    return
  }

  // A page refresh restores localStorage before Vuex.  Do not trust that cached
  // identity while rebuilding dynamic routes: both /me and /menus below must
  // reflect the current server-side session and permissions.
  if (!store.getters.userInfo || !store.getters.routesReady) {
    try {
      await store.dispatch('user/loadCurrentUser')
    } catch (e) {
      await store.dispatch('user/clearSession')
      next(buildLoginLocation(to.fullPath))
      return
    }
  }

  if (!store.getters.routesReady) {
    try {
      await store.dispatch('permission/restoreRoutes')
      next({ ...to, replace: true })
    } catch (e) {
      await store.dispatch('user/clearSession')
      next(buildLoginLocation(to.fullPath))
    }
    return
  }

  if (!canAccessRoute(store.getters.menus, to.path)) {
    next(DEFAULT_REDIRECT)
    return
  }

  next()
})

export default router
